export const ProductVenderMappingConstants = {
    GETALL_REQUEST: 'SECONDARYPACKING_GETALL_REQUEST',
    GETALL_SUCCESS: 'SECONDARYPACKING_GETALL_SUCCESS',
    GETALL_FAILURE: 'SECONDARYPACKING_GETALL_FAILURE',

    GETEXPORT_REQUEST: 'SECONDARYPACKING_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'SECONDARYPACKING_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'SECONDARYPACKING_GETEXPORT_FAILURE',

    GETPDDL_REQUEST: 'SECONDARYPACKING_GETPDDL_REQUEST',
    GETPDDL_SUCCESS: 'SECONDARYPACKING_GETPDDL_SUCCESS',
    GETPDDL_FAILURE: 'SECONDARYPACKING_GETPDDL_FAILURE',

    GETVENDORDDL_REQUEST: 'GETVENDORDDL_REQUEST',
    GETVENDORDDL_SUCCESS: 'GETVENDORDDL_SUCCESS',
    GETVENDORDDL_FAILURE: 'GETVENDORDDL_FAILURE',

    GETVENDORPRODUCT_REQUEST:'GETVENDORPRODUCT_REQUEST',
    GETVENDORPRODUCT_SUCCESS: 'GETVENDORPRODUCT_SUCCESS',
    GETVENDORPRODUCT_FAILURE:'GETVENDORDDL_FAILURE',

    CREATE_REQUEST: 'GiftMaster_CREATE_REQUEST',
    CREATE_SUCCESS: 'GiftMaster_CREATE_SUCCESS',
    CREATE_FAILURE: 'GiftMaster_CREATE_FAILURE',

    CREATE_MAPPING_REQUEST: "CREATE_MAPPING_REQUEST",
    CREATE_MAPPING_SUCCESS: "CREATE_MAPPING_SUCCESS",
    CREATE_MAPPING_FAILURE: "CREATE_MAPPING_FAILURE",


    UPLOAD_SO_REQUEST: "UPLOAD_SO_REQUEST",
    UPLOAD_SO_SUCCESS: "UPLOAD_SO_SUCCESS",
    UPLOAD_SO_PARTIAL_SUCCESS: "UPLOAD_SO_PARTIAL_SUCCESS",
    UPLOAD_SO_FAILURE: "UPLOAD_SO_FAILURE",


    LOADING_REQUEST: 'LOADING_REQUEST'
}